export const SettingTypes = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  JSON: "json",
  ARRAY: "array",
};
